import { forwardRef, useImperativeHandle, useMemo, useState } from "react";
import { Form, message, Modal } from "antd";
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../../components/editForm";
import { GlobalPayServer } from "../../../server";

const server = GlobalPayServer.PayChannel;

const DEFAULT_OPERATION_DATA = {
    Code: "",
    Name: "",
    Sort: 0,
    Status: 1,
}

type OperateModeType = "create" | "update"

const toFormData = (record: any) => ({
    Id: record?.Id,
    Code: record?.Code || "",
    Name: record?.Name || "",
    Sort: record?.Sort || 0,
    Status: record?.Status || 1,
})

export const Operation = forwardRef((props: any, ref: any) => {
    const { onSuccess } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisible] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({ ...DEFAULT_OPERATION_DATA });
    const [form] = Form.useForm();
    const [mode, setMode] = useState<OperateModeType>("create");

    const changeVisible = (val: any, mode?: OperateModeType) => {
        if (val) {
            const data = mode === "update" ? toFormData(val) : { ...DEFAULT_OPERATION_DATA };
            mode && setMode(mode);
            form?.resetFields?.();
            setFormData(data);
        } else {
            form?.resetFields?.();
        }
        setVisible(!!val);
    }

    useImperativeHandle(ref, () => ({ changeVisible }));

    const { run } = useRequest(mode === "create" ? server.create : server.update, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: () => {
            message.success(mode === "create" ? "新增成功" : "更新成功");
            changeVisible(false);
            onSuccess?.();
        }
    });

    const formConfig: FormConfigType = useMemo(() => [
        {
            title: "通道代码",
            field: "Code",
            type: "input",
            placeholder: "请输入通道代码",
            required: true,
        },
        {
            title: "通道名称",
            field: "Name",
            type: "input",
            placeholder: "请输入通道名称",
            required: true,
        },
        {
            title: "排序",
            field: "Sort",
            type: "inputNumber",
            placeholder: "请输入排序",
            style: { width: "100%" },
        },
        {
            title: "状态",
            field: "Status",
            type: "select",
            placeholder: "请选择状态",
            required: true,
            options: [
                { name: "可用", id: 1 },
                { name: "禁用", id: 2 },
            ],
        },
    ], []);

    return (
        <Modal
            title={mode === "create" ? "新增消费支付通道" : "编辑消费支付通道"}
            width={520}
            closeIcon={null}
            maskClosable={false}
            open={visible}
            onCancel={() => changeVisible(false)}
            okButtonProps={{ loading }}
            onOk={async () => {
                await form.validateFields();
                run(formData);
            }}
        >
            <EditForm
                componentId="pay-channel-operation"
                className="mt20"
                form={form}
                formAttrsProps={{
                    labelCol: { span: 7 },
                    wrapperCol: { span: 17 },
                }}
                formData={formData}
                onDataChange={setFormData}
                formConfig={formConfig}
            />
        </Modal>
    );
});
